import {
  BooleanField,
  Datagrid,
  DateField,
  FilterButton,
  List,
  SelectInput,
  TextField,
  TopToolbar,
  ExportButton,
} from 'react-admin';

const leadFilters = [
  <SelectInput
    key="status"
    source="status"
    choices={[
      { id: 'new', name: 'New' },
      { id: 'contacted', name: 'Contacted' },
      { id: 'qualified', name: 'Qualified' },
      { id: 'in_progress', name: 'In Progress' },
      { id: 'won', name: 'Won' },
      { id: 'lost', name: 'Lost' },
    ]}
  />,
  <SelectInput
    key="is_business_owner"
    source="is_business_owner"
    label="Lead Type"
    choices={[
      { id: 'true', name: 'Business Owner' },
      { id: 'false', name: 'Customer' },
    ]}
  />,
];

const ListActions = () => (
  <TopToolbar>
    <FilterButton />
    <ExportButton />
  </TopToolbar>
);

export function LeadList() {
  return (
    <List
      filters={leadFilters}
      actions={<ListActions />}
      sort={{ field: 'created_at', order: 'DESC' }}
    >
      <Datagrid>
        <TextField source="name" />
        <TextField source="phone" />
        <TextField source="email" />
        <BooleanField source="is_business_owner" label="Business Owner" />
        <TextField source="business_type" label="Business Type" />
        <TextField source="notes" label="Message" />
        <TextField source="status" />
        <DateField source="created_at" showTime />
      </Datagrid>
    </List>
  );
}
